// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2kKMl","imageUploader":"EGiftCard_imageUploader__mb_wT"};